import { Navigate, Outlet, useLocation, useOutletContext, useSearchParams } from "react-router-dom";
import { useMe } from "@/api/hooks/auth";
import { PageLoading } from "@/components/Spinner";
import { ErrorNotice } from "@/components/ErrorNotice";
import { useIdleLogout } from "@/lib/idleTimer";
import { safeNext } from "@/lib/safeNext";

function IdleLogout() {
  useIdleLogout(30);
  return null;
}

export function RequireAuth() {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return <PageLoading />;
  if (me.isError) {
    if (me.error.status === 401) {
      const next = `${location.pathname}${location.search}`;
      return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
    }
    return <ErrorNotice error={me.error} />;
  }
  return (
    <>
      <IdleLogout />
      <Outlet />
    </>
  );
}

export function RequireStaff() {
  const me = useMe();
  // Forward the parent's outlet context, e.g. the project when nested under ProjectLayout.
  const context = useOutletContext();
  if (me.isPending) return <PageLoading />;
  if (!me.data?.is_staff) return <Navigate to="/" replace />;
  return <Outlet context={context} />;
}

export function RedirectIfAuthed() {
  const me = useMe();
  const [params] = useSearchParams();
  if (me.isSuccess) return <Navigate to={safeNext(params.get("next"))} replace />;
  if (me.isPending && me.fetchStatus === "fetching") return <PageLoading />;
  return <Outlet />;
}
